import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './MapComponent.css';

// Fix Leaflet marker icons not displaying correctly
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
    iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const MapComponent = () => {
    return (
        <div className="container-fluid my-component">
            <div className="row">
                {/* Section de gauche */}
                <div className="col-md-6 left-section d-flex flex-column align-items-center justify-content-center">

                    <h3>Vous cherchez une date ?</h3><div className="icon">
                        <img
                            loading="lazy"
                            srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/582c026ec5ed04bd244a1a7ee4b06452c6aea6200863fecb3e1cff7dfe59a905?placeholderIfAbsent=true&apiKey=59156c16963f46e28d2e0d857e2bfa45"
                            className="img-13"
                        />
                    </div>
                    <a href='/calendrier' className="btn btn-light">Consulter notre calendrier</a>
                </div>

                {/* Section de droite avec carte interactive */}
                <div className="col-md-6 right-section">
                    <h3 className="text-center text-light">
                        Trouvez une formation SCFPS proche de chez vous ?
                    </h3>
                    <div className="map-container">
                        <a href="/quisommesnous">
                            <MapContainer center={[50.36742449384296, 3.51268790379697]} zoom={12} scrollWheelZoom={true}>
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <Marker position={[50.36742449384296, 3.51268790379697]}>
                                </Marker>
                            </MapContainer>
                        </a>
                    </div>
                </div>
            </div>
        </div>        
    );
};

export default MapComponent;